import { DateTimeEnum } from '@shared/components/date-time-picker/date-time-picker.component';
import {
  EspacoVagaDto,
  EspacoVagaForm,
  EspacoVagaService,
} from './../../../../../shared/services/competition/espaco-vaga.service';
import { Component, inject, OnInit } from '@angular/core';
import { AbstractControl, FormArray, Validators } from '@angular/forms';
import { IArenaDto } from '@models/arena/dtos/arena-dto';
import { ModalSpaceDto } from '@models/arena/dtos/modal-space-dto';
import { ArenaFilterForm } from '@models/arena/filters/arena-filter-form';
import { ICompetitionDto } from '@models/competition-dto';
import { ClashListDto } from '@models/clash/clashes/clash-list-dto';
import { RegistrationFightDto } from '@models/clash/clashes/registration-fight-dto';
import { MetadataPutEnum } from '@models/enums/metadata-put-enum';
import { GenreCateroryEnum } from '@models/enums/genre-category-enum';
import { IEventDto } from '@models/event-dto';
import { IPage } from '@models/pagination/page';
import { ArenaService } from '@shared/services/arena.service';
import { CompetitionBlockService } from '@shared/services/competition-block.service';
import {
  ClashRegistrationService,
  DefinirEmbateForm,
} from '@shared/services/competition/clash-registration/clash-registration.service';
import {
  RodadaDto,
  RodadasService,
} from '@shared/services/competition/rodadas.service';
import { StepParameterizationService } from '@shared/services/competition/step-parametrization.service';
import {
  EspacoRodadaDto,
  EspacoRodadaForm,
  SpaceRoundService,
} from '@shared/services/competition/space-round.service';
import {
  ConfirmationModalService,
  ConfirmationModalType,
  IConfirmationModal,
} from '@shared/services/confirmation-modal.service';
import { EventService } from '@shared/services/event.service';
import { LoadingService } from '@shared/services/loading.service';
import {
  BehaviorSubject,
  catchError,
  distinctUntilChanged,
  filter,
  finalize,
  forkJoin,
  map,
  Observable,
  of,
  switchMap,
  tap,
} from 'rxjs';
import { BaseComponent } from 'src/app/core/utilities/base-component/base-component';
import { InscricaoEmbateDto } from './../../../../../models/embate/clash-dto';
import { IRoundManagementFilter } from '@models/round-management/round-management-filter';
import { provideFilter } from '@shared/services/filter-service/filter.service';
import { FilterKeyEnum } from '@shared/services/filter-service/filter-keys';

@Component({
  selector: 'sigecom-round-management-with-local',
  host: { class: 'block' },
  templateUrl: './round-management-with-local.component.html',
})
export class RoundManagementWithLocalComponent
  extends BaseComponent
  implements OnInit
{
  private rodNrId = -1;
  public readonly petNrId = Number(
    this.activatedRoute.snapshot.paramMap.get('petNrId') || -1,
  );
  public confrontosComHora?: IPage<EspacoRodadaDto>;
  public confrontos?: ClashListDto[];
  public events?: IPage<IEventDto>;
  public competitions?: IPage<ICompetitionDto>;
  public selectedEvent?: IEventDto;
  public selectedCompetition?: ICompetitionDto;
  public selectedPetNrIds: number[] = [];
  public selectedPetNrId = Number(
    this.activatedRoute.snapshot.paramMap.get('petNrId') || -1,
  );
  DateTimeEnum = DateTimeEnum;
  // public confrontosComHoraForm = this.fb.group({
  //   confrontos: this.fb.array<FormGroupOf<ClashWithLocalPutForm>>([]),
  // });
  public rodadaDtoList: RodadaDto[] = [];
  public rodadaDtoView?: RodadaDto;
  public rodadaCurrentIndex = new BehaviorSubject(0);
  public minimize = new BehaviorSubject(false);
  public selectedFilter = new BehaviorSubject<{ key: string; value: string }>({
    key: 'TODOS',
    value: 'all',
  });
  public selectedEmbate = new BehaviorSubject<number | null>(null);
  public selectedLocal = new BehaviorSubject<number | null>(null);
  public filters: { key: string; value: string }[] = [
    { key: 'TODOS', value: 'all' },
    { key: 'MASCULINO', value: 'male' },
    { key: 'FEMININO', value: 'female' },
  ];
  private readonly etapaSexoByPetNrId = new Map<number, GenreCateroryEnum>();

  arenasList?: IPage<IArenaDto>;
  arenaParams: BehaviorSubject<{ filter: ArenaFilterForm; page: number }> =
    new BehaviorSubject({ filter: {}, page: 0 });
  espacoList?: IPage<ModalSpaceDto>;

  public modalAddArena = new BehaviorSubject(false);
  modalAddArenaForm = this.buidAddArenaForm();
  public embModalAddHour = new BehaviorSubject<{
    id: number;
    list: InscricaoEmbateDto[];
  } | null>(null);
  modalAddHourForm = this.buidAddHourForm();

  public filters$ = provideFilter<IRoundManagementFilter>(
    FilterKeyEnum.ROUND_MANAGEMENT_FILTER,
  );

  readonly #arenaService = inject(ArenaService);
  readonly #clashRegistrationService = inject(ClashRegistrationService);
  readonly #roundService = inject(RodadasService);
  readonly #loadingService = inject(LoadingService);
  readonly #spaceRoundService = inject(SpaceRoundService);
  readonly #confirmationModalService = inject(ConfirmationModalService);
  readonly #espacoVagaService = inject(EspacoVagaService);
  readonly #eventService = inject(EventService);
  readonly #competitionBlockService = inject(CompetitionBlockService);
  readonly #stepParametrizationService = inject(StepParameterizationService);

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.loadEvents();
    this.subscribeFilter();
    this.restorePersistedFilter();
    if (this.petNrId > 0) {
      this.selectedPetNrId = this.petNrId;
      this.selectedPetNrIds = [this.petNrId];
      this.loadRoundsByPetNrIds(this.selectedPetNrIds);
    } else {
      this.loadRounds();
    }
    this.loadArenas();
    this.subscribeAreNrIdChanges();
  }

  private restorePersistedFilter(): void {
    const persisted = this.filters$.get();

    if (persisted.sexo) {
      const restoredSexFilter =
        this.filters.find((item) => item.value === persisted.sexo) ??
        this.filters[0];
      this.selectedFilter.next(restoredSexFilter);
    }

    if (!persisted.eveNrId) {
      return;
    }

    this.#eventService.getEventById(persisted.eveNrId).subscribe((event) => {
      this.selectedEvent = event;

      if (!event?.eveNrId) {
        return;
      }

      this.loadCompetitionsByEvent(event.eveNrId, persisted.comNrId);
    });
  }

  adicionarVaga(eprNrId: number) {
    this.#espacoVagaService
      .criar({ eprNrId, entTxMetadado: MetadataPutEnum.CRIADO })
      .pipe(
        switchMap(() => {
          return this.loadConfrontosComHora();
        }),
      )
      .subscribe((v) => (this.confrontosComHora = v));
  }

  adicionarEmbateEmVaga(epvNrId: number) {
    const embNrId = this.selectedEmbate.value;
    if (!embNrId) {
      this.snackbarService.showWarn('Sem embate selecionado');
      return;
    }

    const petNrId = this.getPetNrIdByEmbate(embNrId);
    if (!petNrId || petNrId <= 0) {
      this.snackbarService.showWarn(
        'Etapa não foi localizada para o embate selecionado',
      );
      return;
    }

    const form: DefinirEmbateForm = {
      petNrId,
      epvNrId: epvNrId,
      embNrId: embNrId,
    };

    this.#clashRegistrationService.definirLocalHoraEmbate(form).subscribe({
      next: () => {
        this.selectedEmbate.next(null);
        this.loadConfrontos();
      },
      error: (err) => this.messageErrorResolver.resolveMessage(err),
    });
  }

  removerVaga(vaga: EspacoVagaDto) {
    if (vaga.embateDto != null) {
      this.snackbarService.showWarn(
        'Vaga Com Embate Selecionado, não é possível remover a vaga',
      );
      return;
    }

    this.#espacoVagaService.deletar(vaga.epvNrId).subscribe({
      next: () => {
        this.snackbarService.showSuccess('Vaga removida com sucesso');
        this.loadConfrontosComHora().subscribe(
          (v) => (this.confrontosComHora = v),
        );
      },
      error: (err) => this.messageErrorResolver.resolveMessage(err),
    });
  }

  private getPetNrIdByEmbate(embNrId: number): number {
    const embateSelecionado = this.confrontos?.find(
      (confronto) => confronto.embNrId === embNrId,
    );

    const petNrIdDoEmbate =
      embateSelecionado?.embListInscricaoDto?.[0]?.embateDto?.inscricaoEtapaDto
        ?.petNrId;

    if (petNrIdDoEmbate && petNrIdDoEmbate > 0) {
      return petNrIdDoEmbate;
    }

    if (this.selectedPetNrId > 0) {
      return this.selectedPetNrId;
    }

    if (this.petNrId > 0) {
      return this.petNrId;
    }

    return -1;
  }

  editLocal(local: EspacoRodadaDto) {
    console.log('local', local);

    this.modalAddArenaForm.controls.epcNrId.enable();

    this.modalAddArenaForm.patchValue({
      entNrId: local.eprNrId,
      entTxMetadado: MetadataPutEnum.ALTERADO,
      rodNrId: local.rodNrId,
      areNrId: local.areNrId,
      epcNrId: local.epcNrId,
      eprTmHorarioInicial: local.eprTmHorarioInicial,
      eprNrQuantidadeInscricoes: local.eprNrQuantidadeInscricoes,
      eprBlQuadraPrioritaria: local.eprBlQuadraPrioritaria,
    });
    console.log('value', this.modalAddArenaForm.value);

    this.openModalAddLocal();
  }

  deleteSpace() {
    const args: IConfirmationModal = {
      modalType: ConfirmationModalType.danger,
      confirmText: '',
      cancelText: '',
      message: 'Deseja deletar ',
      callbackExecuteAction: () => {
        this.#deleteSpace();
      },
    };
    this.#confirmationModalService.openModal(args);
  }

  #deleteSpace() {
    this.#spaceRoundService
      .deletar(this.modalAddArenaForm.value.entNrId!)
      .pipe(
        tap(() => {
          this.snackbarService.showInfo(
            'Espaço removido da rodada com sucesso',
          );
        }),
        switchMap(() => {
          return this.loadConfrontosComHora();
        }),
      )
      .subscribe({
        next: (confrontosComHora) => {
          this.confrontosComHora = confrontosComHora;
          this.closeModalAddLocal();
        },
        error: (err) => {
          this.messageErrorResolver.resolveMessage(err);
        },
      });
  }

  saveSpaceInRound() {
    const isEdit = !!this.modalAddArenaForm.value.entNrId;

    const rodNrId = this.rodNrId;
    const form = this.modalAddArenaForm;
    const formValue = this.modalAddArenaForm.value;
    formValue.rodNrId = this.rodNrId;
    if (!isEdit) {
      formValue.entTxMetadado = MetadataPutEnum.CRIADO;
    }
    if (!rodNrId || form.invalid) {
      return;
    }

    const request$ = !isEdit
      ? this.#spaceRoundService.criar(formValue as EspacoRodadaForm)
      : this.#spaceRoundService.editar(formValue as EspacoRodadaForm);

    request$
      .pipe(
        tap((_) => this.#loadingService.activate()),
        switchMap((_) => {
          this.closeModalAddLocal();
          return this.loadConfrontosComHora();
        }),
      )
      .subscribe({
        next: (confrontosComHora) => {
          this.confrontosComHora = confrontosComHora;
          this.modalAddArenaForm.reset();
          this.snackbarService.showSuccess('Espaço adicionado com sucesso!');
        },
        error: (err) => this.messageErrorResolver.resolveMessage(err),
        complete: () => this.#loadingService.deactivate(),
      });
  }

  navigateToEdit() {
    this.router
      .navigate(['parametrizacao-etapa', 'editar', this.petNrId])
      .then();
  }

  updateClash(
    embNrId?: number,
    saveHour?: boolean,
    skipIntervalValidation = false,
  ) {
    const eprNrId = this.selectedLocal.value ?? undefined;
    if (!eprNrId && !saveHour) {
      this.snackbarService.showWarn('Sem local selecionado');
      return;
    }

    if (!embNrId) {
      this.snackbarService.showWarn('Sem embate selecionado');
      return;
    }
    let embDtDataHoraEmbate: string | undefined;
    if (saveHour && this.modalAddHourForm.valid) {
      embDtDataHoraEmbate =
        this.modalAddHourForm.value.embDtDataHoraEmbate ?? undefined;
    }

    const form: EspacoVagaForm = {
      epvTmInicio: embDtDataHoraEmbate,
      entNrId: this.embModalAddHour.value?.id,
      eprNrId: eprNrId,
      entTxMetadado: MetadataPutEnum.ALTERADO,
      ...(skipIntervalValidation && { epvBlValidaIntervalo: false }),
    };

    this.#espacoVagaService
      .editar(form)
      .pipe(
        switchMap((_) => {
          return this.loadConfrontosComHora();
        }),
      )
      .subscribe({
        next: (confrontosComHora) => {
          this.confrontosComHora = confrontosComHora;
          this.modalAddHourForm.reset();
          let message = 'Confronto adicionado no espaço';
          if (saveHour) {
            this.closeModalAddHour();
            message = 'Horário do confronto marcado!';
          }
          this.snackbarService.showSuccess(message);
        },
        error: (err) => {
          if (saveHour && !skipIntervalValidation && this.isIntervalConflict(err)) {
            this.#confirmationModalService.openModal({
              modalType: ConfirmationModalType.warn,
              title: 'Horário fora do intervalo recomendado',
              description:
                'O horário informado não respeita o intervalo recomendado entre os jogos. Deseja prosseguir mesmo assim?',
              confirmText: 'Sim',
              cancelText: 'Não',
              callbackExecuteAction: () =>
                this.updateClash(embNrId, saveHour, true),
            });
            return;
          }

          this.messageErrorResolver.resolveMessage(err);
        },
      });
  }

  private isIntervalConflict(error: unknown): boolean {
    return (
      typeof error === 'object' &&
      error !== null &&
      'status' in error &&
      error.status === 409
    );
  }

  getIncName(emb?: InscricaoEmbateDto | RegistrationFightDto) {
    return emb?.estTxNome ?? emb?.iemTxNomeDefault;
  }

  getParticipantKeyName(
    emb?: InscricaoEmbateDto | RegistrationFightDto,
    fallbackKeyName?: string | null,
  ): string {
    return fallbackKeyName || '';
  }

  removerEmbateDaVaga(vaga: EspacoVagaDto) {
    this.#confirmationModalService.openModal({
      modalType: ConfirmationModalType.danger,
      confirmText: 'Remover',
      cancelText: 'Cancelar',
      message: 'Deseja desvincular este confronto da vaga?',
      callbackExecuteAction: () => {
        this.#espacoVagaService.removerEmbateDaVaga(vaga.epvNrId).subscribe({
          next: () => {
            this.snackbarService.showSuccess(
              'Confronto desvinculado da vaga com sucesso',
            );
            this.loadConfrontos();
          },
          error: (err) => this.messageErrorResolver.resolveMessage(err),
        });
      },
    });
  }

  getModalityName(petNrId?: number): string {
    const competition = this.selectedCompetition;
    const sport = competition?.comObjEsporte?.espTxDescricao;
    const gender =
      petNrId && petNrId > 0
        ? this.etapaSexoByPetNrId.get(petNrId)
        : this.selectedPetNrId > 0
          ? this.etapaSexoByPetNrId.get(this.selectedPetNrId)
          : undefined;
    const genderName = gender
      ? String(gender).toLowerCase() === 'masculina'
        ? 'masculino'
        : 'feminino'
      : '';
    return (
      [sport, genderName].filter(Boolean).join(' ') ||
      competition?.comTxNome ||
      '-'
    );
  }

  getModalityAcronym(petNrId?: number): string {
    return this.getModalityName(petNrId)
      .split(/\s+/)
      .filter(Boolean)
      .map((word) => word.charAt(0).toUpperCase())
      .join('');
  }

  getModalityAcronymByClash(clash: ClashListDto): string {
    const chave = clash.chaveEmbateSimplesDto;
    const modalidade = chave?.comTxNome?.trim()?.charAt(0) ?? '';
    const naipe = chave?.catTxSexo?.trim()?.charAt(0) ?? '';
    return (
      `${modalidade}${naipe}`.toUpperCase() ||
      this.getModalityAcronym(this.getPetNrIdByClash(clash))
    );
  }

  getModalityAcronymByVaga(vaga: EspacoVagaDto): string {
    const chave = vaga.embateDto?.chaveEmbateSimplesDto;
    const modalidade = chave?.comTxNome?.trim()?.charAt(0) ?? '';
    const naipe = chave?.catTxSexo?.trim()?.charAt(0) ?? '';
    return (
      `${modalidade}${naipe}`.toUpperCase() ||
      this.getModalityAcronym(this.getPetNrIdByVaga(vaga))
    );
  }

  getPetNrIdByClash(clash: ClashListDto): number | undefined {
    return clash.embListInscricaoDto?.[0]?.embateDto?.inscricaoEtapaDto
      ?.petNrId;
  }

  getPetNrIdByVaga(vaga: EspacoVagaDto): number | undefined {
    return vaga.embateDto?.embListInscricaoDto?.[0]?.embateDto
      ?.inscricaoEtapaDto?.petNrId;
  }

  getEmbateInscricao(
    vagaOrList?:
      | {
          embateDto?: {
            embListInscricaoDto?: InscricaoEmbateDto[] | null;
          } | null;
        }
      | InscricaoEmbateDto[]
      | null,
    index: number = 0,
  ): InscricaoEmbateDto | undefined {
    if (Array.isArray(vagaOrList)) {
      return vagaOrList[index];
    }

    const embateDto = vagaOrList?.embateDto;
    if (!embateDto) {
      return undefined;
    }

    const list = Array.isArray(embateDto.embListInscricaoDto)
      ? embateDto.embListInscricaoDto
      : undefined;

    return list?.[index];
  }

  getEmbateInscricaoByModal(
    emb?: { value?: { list?: InscricaoEmbateDto[] | null } | null } | null,
    index: number = 0,
  ): InscricaoEmbateDto | undefined {
    return emb?.value?.list?.[index];
  }

  getIncData(emb?: InscricaoEmbateDto) {
    return emb?.embateDto?.inscricaoEtapaDto?.ineObjInscricao;
  }

  getDataMinima(): string {
    const today = new Date();

    const rodadaInicio = this.rodadaDtoView?.rodDtInicio
      ? new Date(this.rodadaDtoView.rodDtInicio)
      : null;
    rodadaInicio?.setHours(0, 0, 0, 0);

    const minDate =
      rodadaInicio && rodadaInicio >= today ? rodadaInicio : today;

    return this.formatDateTimeInput(minDate);
  }

  getDataMaxima(): string {
    let maxDate: Date;

    if (this.rodadaDtoView?.rodDtFim) {
      const [ano, mes, dia] = this.rodadaDtoView.rodDtFim
        .split('-')
        .map(Number);

      maxDate = new Date(ano, mes - 1, dia);
    } else {
      maxDate = new Date();
    }

    maxDate.setHours(23, 59, 0, 0);

    const v = this.formatDateTimeInput(maxDate);

    return v;
  }

  private formatDateTimeInput(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  subscribeFilter() {
    this.selectedFilter
      .pipe(
        distinctUntilChanged((a, b) => a.value === b.value),
        tap((f) => {
          console.log('changed filter to', f.value);
          this.selectedEmbate.next(null);
          this.loadConfrontos();
        }),
        this.takeUntilDestroy(),
      )
      .subscribe();
  }

  onSexFilterChange(filterValue: string): void {
    const nextFilter =
      this.filters.find((item) => item.value === filterValue) ??
      this.filters[0];

    if (nextFilter.value === this.selectedFilter.value.value) {
      return;
    }

    this.selectedFilter.next(nextFilter);
    this.filters$.patch({ sexo: nextFilter.value });
  }

  onSemLocalFilterChange(checked: boolean): void {
    this.selectedEmbate.next(null);
    this.filters$.patch({ embBlEmbatesSemLocal: checked });
    this.loadConfrontos();
  }

  protected delete(emb: EspacoVagaDto) {
    console.warn('DELETE NOT IMPLEMENTED');
  }
  openGamesTable() {
    this.router.navigate(['/tabela-jogos']);
  }

  private loadConfrontos() {
    const petNrIdsSemFiltro = this.selectedPetNrIds.length
      ? this.selectedPetNrIds
      : this.petNrId > 0
        ? [this.petNrId]
        : [];

    const petNrIds = this.filterPetNrIdsBySexo(petNrIdsSemFiltro);

    if (this.rodNrId < 0) {
      this.confrontos = [];
      this.confrontosComHora = undefined;
      return;
    }

    if (!petNrIds.length) {
      this.confrontos = [];
      this.loadConfrontosComHora().subscribe({
        next: (confrontosComHora: IPage<EspacoRodadaDto> | undefined) => {
          this.confrontosComHora = confrontosComHora;
        },
      });
      return;
    }

    forkJoin({
      confrontos: forkJoin(
        petNrIds.map((petNrId) =>
          this.#clashRegistrationService.getRegistraionClash(
            {
              rodNrId: this.rodNrId,
              petNrIds: [petNrId],
              embBlEmbatesSemLocal: true,
            },
            { page: 0, size: 999 },
          ),
        ),
      ).pipe(map((pages) => pages.flatMap((page) => page.content ?? []))),
      confrontosComHora: this.loadConfrontosComHora(),
    }).subscribe(({ confrontos, confrontosComHora }) => {
      this.confrontos = confrontos;
      this.confrontosComHora = confrontosComHora;
    });
  }

  private filterPetNrIdsBySexo(petNrIds: number[]): number[] {
    const selectedValue = this.selectedFilter.value.value;

    if (selectedValue === 'all') {
      return petNrIds;
    }

    const selectedSexo =
      selectedValue === 'male'
        ? GenreCateroryEnum.Masculina
        : GenreCateroryEnum.Feminina;

    return petNrIds.filter(
      (petNrId) => this.etapaSexoByPetNrId.get(petNrId) === selectedSexo,
    );
  }
  loadConfrontosComHora(): Observable<IPage<EspacoRodadaDto> | undefined> {
    return this.rodNrId >= 0
      ? this.#spaceRoundService.listarPorRodada(this.rodNrId)
      : of(undefined);
  }

  getConfrontoEmbates(confrontoControl: AbstractControl): AbstractControl[] {
    return ((confrontoControl.get('embListEmbates') as FormArray)?.controls ??
      []) as AbstractControl[];
  }

  getConfrontoInscricoes(
    embateControl: AbstractControl,
  ): Array<{ iemTxNome?: string }> {
    return (embateControl.get('embListInscricoes')?.value ?? []) as Array<{
      iemTxNome?: string;
    }>;
  }

  private subscribeAreNrIdChanges() {
    const epcNrId = this.modalAddArenaForm.controls.epcNrId;
    this.modalAddArenaForm.controls.areNrId.valueChanges
      .pipe(
        distinctUntilChanged(),
        tap((v) => {
          if (!v) {
            epcNrId.disable();
            this.espacoList = undefined;
          }
        }),
        filter((v) => v != null),
        switchMap((v) => {
          return this.#arenaService.findSpacesByAreNrId(v!);
        }),
      )
      .subscribe({
        next: (spaces) => {
          epcNrId.enable();
          this.espacoList = spaces;
        },
        error: (err) => {
          epcNrId.disable();
          this.messageErrorResolver.resolveMessage(err);
        },
      });
  }

  subscribeRodadaPageChange() {
    this.rodadaCurrentIndex
      .pipe(
        distinctUntilChanged(),
        tap((index) => {
          this.rodadaDtoView = this.rodadaDtoList?.[index];
          this.rodNrId = this.rodadaDtoView?.rodNrId;
          this.selectedLocal.next(null);
          this.loadConfrontos();
        }),
      )
      .subscribe();
  }

  private buidAddArenaForm() {
    return this.fb.group({
      entNrId: this.fb.control<number | null>(null),
      entTxMetadado: this.fb.control<MetadataPutEnum | null>(null),
      rodNrId: this.fb.control<number | null>(null),
      areNrId: this.fb.control<number | null>(null, Validators.required),
      epcNrId: this.fb.control<number | null>(
        { value: null, disabled: true },
        Validators.required,
      ),
      eprTmHorarioInicial: this.fb.control<string | null>(
        null,
        Validators.required,
      ),
      eprNrQuantidadeInscricoes: this.fb.control<number | null>(null),
      eprBlQuadraPrioritaria: this.fb.control(false),
      eprBlTodasAsRodadas: this.fb.control(false),
    });
  }
  private buidAddHourForm() {
    return this.fb.group({
      embDtDataHoraEmbate: this.fb.control<string | null>(
        null,
        Validators.required,
      ),
    });
  }

  private loadEvents(searchTerm?: string) {
    const filter = searchTerm ? { eveTxNome: searchTerm } : undefined;

    this.#eventService.getAllAvailableEvents(0, 100, filter).subscribe({
      next: (res) => {
        this.events = res ?? { content: [] };
      },
      error: (err) => this.messageErrorResolver.resolveMessage(err),
    });
  }

  onEventSearch(searchText: string) {
    this.loadEvents(searchText?.trim());
  }

  private loadCompetitionsByEvent(eventId: number, comNrIdToRestore?: number) {
    this.#eventService
      .getAllCompetitionBlocksByEvent$(eventId)
      .pipe(
        switchMap((blocks) => {
          const blockIds = (blocks.content ?? [])
            .map((block) => block.bloNrId)
            .filter((id): id is number => !!id);

          if (!blockIds.length) {
            return of([]);
          }

          return forkJoin(
            blockIds.map((bloNrId) =>
              this.#competitionBlockService.getAllCompetitionByBlocks(
                bloNrId,
                0,
                100,
              ),
            ),
          ).pipe(
            map((pages) =>
              pages
                .flatMap((page) => page.content ?? [])
                .filter(
                  (competition, index, list) =>
                    list.findIndex(
                      (item) => item.comNrId === competition.comNrId,
                    ) === index,
                ),
            ),
          );
        }),
      )
      .subscribe({
        next: (competitions) => {
          this.competitions = {
            content: competitions,
          } as IPage<ICompetitionDto>;

          if (comNrIdToRestore) {
            const restored = competitions.find(
              (c) => c.comNrId === comNrIdToRestore,
            );
            if (restored) {
              this.onCompetitionChange(restored);
            }
          }
        },
        error: (err) => this.messageErrorResolver.resolveMessage(err),
      });
  }

  onEventChange(event: IEventDto | null) {
    this.selectedEvent = event ?? undefined;
    this.selectedCompetition = undefined;
    this.competitions = { content: [] } as IPage<ICompetitionDto>;
    this.clearSelectedPhaseData();
    this.filters$.patch({
      eveNrId: event?.eveNrId,
      comNrId: undefined,
      petNrId: undefined,
    });

    if (!event?.eveNrId) {
      return;
    }

    this.loadCompetitionsByEvent(event.eveNrId);
  }

  onCompetitionChange(competition: ICompetitionDto | null) {
    this.selectedCompetition = competition ?? undefined;
    this.filters$.patch({ comNrId: competition?.comNrId });

    if (!competition?.comNrId) {
      this.clearSelectedPhaseData();
      return;
    }

    this.#stepParametrizationService
      .getSimpleStepParametrization$(
        { eveNrId: this.selectedEvent?.eveNrId, comNrId: competition.comNrId },
        { page: 0, size: 100 },
      )
      .subscribe({
        next: (page) => {
          this.etapaSexoByPetNrId.clear();
          (page.content ?? []).forEach((item) => {
            if (item.petNrId) {
              this.etapaSexoByPetNrId.set(item.petNrId, item.catTxSexo);
            }
          });

          const petNrIds = (page.content ?? [])
            .map((item) => item.petNrId)
            .filter((petNrId): petNrId is number => !!petNrId);

          this.selectedPetNrIds = [...new Set(petNrIds)];
          this.selectedPetNrId = this.selectedPetNrIds[0] ?? this.petNrId;

          if (!this.selectedPetNrIds.length) {
            this.clearSelectedPhaseData();
            return;
          }

          this.filters$.patch({ petNrId: this.selectedPetNrId });
          this.loadRoundsByPetNrIds(this.selectedPetNrIds);
        },
        error: (err) => this.messageErrorResolver.resolveMessage(err),
      });
  }

  private clearSelectedPhaseData() {
    this.selectedPetNrIds = [];
    this.selectedPetNrId = this.petNrId > 0 ? this.petNrId : -1;
    this.etapaSexoByPetNrId.clear();
    this.selectedFilter.next(this.filters[0]);
    this.rodadaDtoList = [];
    this.rodadaDtoView = undefined;
    this.rodNrId = -1;
    this.rodadaCurrentIndex.next(0);
    this.confrontos = [];
    this.confrontosComHora = undefined;
  }

  private loadRoundsByPetNrIds(petNrIds: number[]) {
    forkJoin(
      petNrIds.map((petNrId) =>
        this.#roundService
          .buscarRodadasPorEtapa(petNrId)
          .pipe(map((response) => response.response ?? [])),
      ),
    )
      .pipe(
        map((rodadasPorEtapa) =>
          rodadasPorEtapa
            .flat()
            .filter(
              (rodada, index, list) =>
                list.findIndex((item) => item.rodNrId === rodada.rodNrId) ===
                index,
            )
            .sort((a, b) => a.rodNrOrdemExecucao - b.rodNrOrdemExecucao),
        ),
      )
      .subscribe({
        next: (rodadas) => {
          this.rodadaDtoList = rodadas;
          this.rodadaDtoView =
            this.rodadaDtoList[this.rodadaCurrentIndex.value];
          if (this.rodadaDtoView) {
            this.rodNrId = this.rodadaDtoView.rodNrId;
            this.loadConfrontos();
          } else {
            this.rodNrId = -1;
            this.confrontos = [];
          }
          this.subscribeRodadaPageChange();
        },
        error: (err) => this.messageErrorResolver.resolveMessage(err),
      });
  }

  private loadRounds() {
    this.#loadingService.activate();
    this.#roundService
      .buscarRodadasPorEtapa(this.petNrId)
      .pipe(
        finalize(() => this.#loadingService.deactivate()),
        tap((rodadas) => {
          console.log(rodadas);
          this.rodadaDtoList = rodadas.response;
          this.rodadaDtoView =
            this.rodadaDtoList[this.rodadaCurrentIndex.value];
        }),
        catchError((err) => {
          this.messageErrorResolver.resolveMessage(err);
          return of([]);
        }),
      )
      .subscribe((_) => this.subscribeRodadaPageChange());
  }

  private loadArenas() {
    const params = this.arenaParams.value;
    this.#arenaService
      .findArenas$(params.filter, { page: params.page, size: 20 })
      .subscribe((v) => {
        this.arenasList = v;
      });
  }

  openModalAddLocal() {
    this.modalAddArena.next(true);
  }

  montarPreTabela() {
    const { eveNrId, comNrId } = this.filters$.get();
    if (!eveNrId || !comNrId) {
      this.snackbarService.showWarn('Selecione um evento e uma competição para montar a pré-tabela');
      return;
    }

    this.#loadingService.activate();
    this.#spaceRoundService
      .distribuirEmbatesNosEspacos(eveNrId, comNrId)
      .subscribe({
        next: () => {
          this.selectedEmbate.next(null);
          this.loadConfrontos();
          this.snackbarService.showSuccess('Pré-tabela montada com sucesso!');
        },
        error: (err) => this.messageErrorResolver.resolveMessage(err),
      });
  }

  closeModalAddLocal() {
    this.modalAddArena.next(false);
    this.modalAddArenaForm.reset();
  }
  openModalAddHour(vaga: EspacoVagaDto) {
    this.selectedLocal.next(vaga.eprNrId);
    this.modalAddHourForm.patchValue({
      embDtDataHoraEmbate: vaga.epvTmInicio ?? null,
    });
    this.embModalAddHour.next({
      id: vaga.epvNrId,
      list: vaga.embateDto?.embListInscricaoDto!,
    });
  }

  closeModalAddHour() {
    this.embModalAddHour.next(null);
    this.selectedLocal.next(null);
    this.modalAddHourForm.reset();
  }

  toggleMinimize() {
    this.minimize.next(!this.minimize.value);
  }

  changeRodadasPage(arg0: 'next' | 'prev') {
    const current = this.rodadaCurrentIndex.getValue();
    switch (arg0) {
      case 'prev':
        if (current > 0) {
          this.rodadaCurrentIndex.next(current - 1);
        }
        break;
      case 'next':
        if (current == (this.rodadaDtoList?.length || 0) - 1) return;
        this.rodadaCurrentIndex.next(current + 1);
        break;
    }
  }

  get hasContextoCompleto(): boolean {
    return !!(this.selectedEvent?.eveNrId && this.selectedCompetition?.comNrId);
  }
}
